export const getChardonnayFranceData = () => ({
  name: "Chardonnay",
  country: "France",
  description: "Le Chardonnay est le cépage blanc principal de Bourgogne, produisant les vins blancs les plus prestigieux.",
  regions: [
    { name: "Côte de Beaune", area: "4,200 ha", percentage: "45%", description: "Grands crus blancs" },
    { name: "Chablis", area: "3,800 ha", percentage: "41%", description: "Vins minéraux" },
    { name: "Mâconnais", area: "800 ha", percentage: "9%", description: "Vins de terroir" },
    { name: "Côte Chalonnaise", area: "400 ha", percentage: "4%", description: "Usage limité" },
    { name: "Autres", area: "100 ha", percentage: "1%", description: "Dispersé en Bourgogne" }
  ],
  mapAreas: [
    { region: "Côte de Beaune", x: 54, y: 38, color: "#4B164C", size: 7 },
    { region: "Chablis", x: 58, y: 30, color: "#6d2c7a", size: 6 },
    { region: "Mâconnais", x: 52, y: 45, color: "#8a4a8a", size: 3 },
    { region: "Côte Chalonnaise", x: 53, y: 42, color: "#a768a6", size: 2 }
  ],
  subregions: {
    bourgogne: {
      name: "Bourgogne",
      description: "Le Chardonnay de Bourgogne produit les vins blancs les plus complexes et les plus recherchés au monde.",
      characteristics: {
        aromas: "Citron, pomme, beurre, noisette, notes minérales",
        body: "Corps moyen à plein",
        acidity: "Acidité vive et structurée",
        aging: "Excellent potentiel (10-25 ans)"
      },
      terroir: {
        climate: "Climat continental tempéré",
        soil: "Sols calcaires et argilo-calcaires",
        viticulture: "Rendements limités, élevage en fûts de chêne"
      },
      differentiators: [
        "Complexité aromatique exceptionnelle",
        "Équilibre parfait acidité-richesse",
        "Expression du terroir très marquée",
        "Notes minérales distinctives"
      ],
      foodPairing: "Poissons, crustacés, volailles, fromages affinés"
    }
  }
}); 